<template lang="pug">
  #app.off-canvas(:data-view='view')
    header.navbar(v-shortkey.once='["esc"]' @shortkey='closeModals()')
      .navbar-section
        a(href='/')
          img.logo.mr-3(style='margin-left: 10px' src='static/img/favicon.png')
          | Nonprofiters
      .navbar-section
        .off-canvas-toggle.btn.btn-link.btn-action(@click='toggleSidebar')
          .icon.icon-menu

    .off-canvas-sidebar(:class='{active: isMainSidebarActive}' style='box-shadow: 0 0 3px rgba(0,0,0,0.35)')
      .sidebar-section.text-center
        a(href='/')
          img.logo(src='static/img/favicon.png')
          | Nonprofiters
      .sidebar-section.text-center(v-if='user.uid')
        p
          figure.avatar.avatar-xl
            img(:src='user.providerData[0].photoURL.replace("_normal", "_bigger")' :alt='user.displayName')
        //- @TODO parse emojis in displayName
        p {{user.displayName}}

      .sidebar-section
        p.btn-group.btn-group-block(v-if='user.uid')
            button.btn(@click='logout') Logout
            button.btn.btn-primary(@click='toggleProfile') Settings
        p.btn-group.btn-group-block(v-if='!user.uid')
          button.btn(@click='toggleLogin') Sign In

      .sidebar-section
        p.btn-group.btn-group-block
          button.btn.btn-primary(v-if='checklist && view === "main"' @click='gotoChecklist') View Checklist
          button.btn(ref='btnViewAllResources' v-if='checklist && view === "checklist"' @click='gotoMain') View All Resources
          button.btn.btn-primary(v-if='!checklist' @click='toggleIntakeModal') Start Here!

        p.btn-group.btn-group-block(v-if='!user.uid && checklist')
          button.btn.btn-group-block(@click='toggleIntakeModal') Edit Intake Answers

      .sidebar-section
        ul
          li
            a(@click='toggleAbout') About

      .sidebar-section(v-if='user.uid && view === "main"')
        p.btn-group.btn-group-block
          button.btn(@click='toggleResourceModal()' v-shortkey.once='["a"]' @shortkey='toggleResourceModal()') Add Resource

    .off-canvas-overlay(@click='toggleSidebar')

    main(ref='main').off-canvas-content
      #main
        map-main(style='height: 200px' ref='header')
        map-key(
          ref='key'
          :class='{hidden: view !== "main"}')
        #main-footer(ref='footer')
          resource-listing(v-if='view !== "checklist"' ref='resourceListing')
          checklist-overview(v-else)

    //- Modals
    modal-login(v-if='!user.uid && isLoginModalActive')
    modal-profile(v-if='user.uid && isProfileModalActive')
    modal-resource(v-if='user.uid && isResourceModalActive')
    modal-intake(v-if='isIntakeModalActive')
    modal-about(v-if='isAboutModalActive')
    modal-intake-config(v-if='isIntakeConfigModalActive')
</template>





<script>
  import ModalLogin from '@/components/modal/Login'
  import ModalProfile from '@/components/modal/Profile'
  import ModalResource from '@/components/modal/Resource'
  import ModalAbout from '@/components/modal/About'
  import ModalIntake from '@/components/modal/Intake'
  import ModalIntakeConfig from '@/components/modal/IntakeConfig'
  import MapMain from '@/components/map/Main'
  import MapKey from '@/components/map/Key'
  import ChecklistOverview from '@/components/checklist/Overview'
  import ResourceListing from '@/components/resource/Listing'
  import {mapState} from 'vuex'
  import lockr from 'lockr'

  // @TODO Remove this migration script entirely once we have a backup of the migrated database somewhere safe, preferrably in another firestore instance
  // import V1Migrations from '@/components/admin/V1Migrations'

  export default {
    name: 'layout-main',

    components: {
      ModalAbout,
      ModalResource,
      ModalIntake,
      ModalLogin,
      ModalProfile,
      ModalIntakeConfig,
      MapMain,
      MapKey,
      ResourceListing,
      ChecklistOverview
    },

    computed: mapState([
      'isMainSidebarActive',
      'isAboutModalActive',
      'isLoginModalActive',
      'isProfileModalActive',
      'isIntakeModalActive',
      'isIntakeConfigModalActive',
      'isResourceModalActive',
      'view',
      'user',
      'resources',
      'checklist'
    ]),

    props: [
      'preloadIntakeModal',
      'viewChecklist'
    ],

    data () {
      return {
        isDragging: false,
        dragStartY: 0,
        initMapHeight: lockr.get('initMapHeight') || '250px'
      }
    },

    created () {
      // Route: /start
      if (this.preloadIntakeModal) this.$store.commit('toggleIntakeModal')
      // Route: /checklist
      else if (this.viewChecklist) this.$store.commit('viewChecklist')
      // Route: /
      else this.$store.commit('viewMain')

      this.$store.commit('filterResources')
    },

    mounted () {
      // Handle Resizers
      this.$refs.header.$el.style.height = this.initMapHeight

      this.handleResize()
      window.addEventListener('resize', this.handleResize)
      this.$refs.key.$el.addEventListener('mousedown', this.startKeyResize)
      this.$el.addEventListener('mouseup', this.stopKeyResize)
      this.$refs.key.$el.addEventListener('touchstart', this.startTouchKeyResize)
      this.$el.addEventListener('touchend', this.stopKeyResize)
      this.$refs.main.addEventListener('mousemove', this.maybeDoKeyResize)
      this.$refs.main.addEventListener('touchmove', this.maybeDoTouchKeyResize)

      // Just in case
      // @TODO figure out why calling it once above doesn't work (my guess is that I should user innerHeight or something)
      setTimeout(() => this.handleResize(), 1000)
      setTimeout(() => this.handleResize(), 3000)
    },

    watch: {
      $route (to, from) {
        if ((to.path === '/' && this.isIntakeModalActive) ||
          (to.path === '/start' && !this.isIntakeModalActive)) this.$store.commit('toggleIntakeModal')
        else if ((to.path === '/checklist')) this.$store.commit('viewChecklist')
        else if (to.path === '/') this.$store.commit('viewMain')

        this.$store.commit('filterResources')
        this.$nextTick(() => this.handleResize())
      }
    },

    methods: {
      toggleSidebar () {
        this.$store.commit('toggleMainSidebar')
      },
      toggleLogin () {
        this.$store.commit('toggleLoginModal')
      },
      toggleProfile () {
        this.$store.commit('toggleProfileModal')
      },
      toggleResourceModal (resource) {
        this.$store.commit('toggleResourceModal', resource)
      },
      toggleAbout () {
        this.$store.commit('toggleAboutModal')
      },
      toggleIntakeModal () {
        this.$store.commit('toggleIntakeModal')
        if (!this.checklist) {
          this.$router.push('/start')
        }
      },
      gotoChecklist () {
        this.$router.push('/checklist')
      },
      gotoMain () {
        this.$refs.btnViewAllResources.classList.add('loading')
        setTimeout(() => {
          this.$router.push('/')
        }, 100)
      },
      logout () {
        this.$store.commit('logout')
      },
      closeModals () {
        this.$store.commit('closeModals')
        this.$router.push('/')
      },

      /**
       * Handles the panel sizes
       */
      handleResize () {
        const $main = this.$refs.main
        const $header = this.$refs.header.$el
        const $key = this.$refs.key.$el
        const $footer = this.$refs.footer

        const mainHeight = $main.clientHeight
        const headerHeight = $header.clientHeight
        const keyHeight = this.view !== 'main' ? 0 : $key.clientHeight
        const footerHeight = mainHeight - headerHeight - keyHeight

        $header.style.height = `${headerHeight}px`
        $footer.style.height = `${footerHeight}px`
      },

      /**
       * Resize the panes via key drag
       */
      startKeyResize (ev) {
        this.dragStartY = ev.offsetY
        this.isDragging = true
      },
      startTouchKeyResize (ev) {
        let touch = ev.changedTouches[0]
        touch.offsetY = touch.screenY - this.$refs.key.$el.offsetTop - 10 - this.$refs.header.$el.offsetTop
        this.startKeyResize(touch)
      },

      maybeDoKeyResize (ev) {
        if (this.isDragging) {
          const $header = this.$refs.header.$el
          const $key = this.$refs.key.$el

          $header.style.height = this.initMapHeight = `${ev.screenY - this.dragStartY - $key.clientHeight - $header.offsetTop - 10}px`
          this.handleResize()
        }
      },
      maybeDoTouchKeyResize (ev) {
        this.maybeDoKeyResize(ev.changedTouches[0])
      },

      stopKeyResize () {
        lockr.set('initMapHeight', this.initMapHeight)
        window.google.maps.event.trigger(this.$refs.header.$refs.map.$mapObject, 'resize')
        this.isDragging = false
      }
    }
  }
</script>





<style lang="sass">
  @import "../assets/sass/main"

  .sidebar-section
    padding: $padding-main
    border-bottom: 1px solid $border-color
    &:last-child
      border-bottom: none

    p
      margin-bottom: $padding-main
      &:last-child
        margin-bottom: 0

  .off-canvas-sidebar
    ul, li
      list-style: none
      margin: 0
      a
        display: block
        padding: 10px 0

  .logo
    vertical-align: middle
    margin-right: 10px
    width: 32px
    position: relative
    top: 0px

  .off-canvas-content
    padding: 0 !important

  #app > header
    display: none

  #main-footer
    overflow: auto

  @media screen and (max-width: $size-lg)
    #app
      padding-top: $header-height

      > header
        position: fixed
        display: flex !important
        height: $header-height
        width: 100%
        top: 0
        left: 0
        padding: 21px

        .off-canvas-toggle
          position: relative
          left: 0
          top: 0
</style>



// WEBPACK FOOTER //
// src/layouts/Main.vue